<template>
	<div class="custom-page">
		<v-container fluid class="custom-page-container" v-if="page && page.type === 'Internal'">
			<v-row no-gutters v-for="(row, index) in pageLayout" :key="index">
				<v-col class="custom-page-column" v-for="col in row" :key="'key' + col.contentIndex" :md="col.cols" cols="12">
					<content-block :index="col.contentIndex" :content="page.content"></content-block>
				</v-col>
			</v-row>
		</v-container>
		<div v-else-if="page && page.type === 'iFrame'" class="custom-page-iframe">
			<iframe :src="page.hyperLink" :title="page.title" scrolling="auto"></iframe>
		</div>
	</div>
</template>

<script>
	import ContentBlock from '@/modules/custom/ContentBlock';

	export default {
		name: 'CustomPage',

		props: ['slug'],

		components: { ContentBlock },

		methods: {
			colsInRow: function(row, contentIndex) {
				let cols = 12 / row.cols;
				let result = [];
				let i = cols;

				while (i <= 12) {
					result.push({
						cols: cols,
						contentIndex: contentIndex.index++,
					});

					i = i + cols;
				}
				return result;
			},
		},

		computed: {
			page() {
				return this.$store.state.customPages.find((customPage) => customPage.slug === this.slug) || null;
			},

			layoutOptions: function() {
				let options = [];
				options.push({
					label: 'Single page',
					key: '1',
					layout: [{ cols: 1 }],
				});

				options.push({
					label: 'Side-by-side',
					key: '2',
					layout: [{ cols: 2 }],
				});
				options.push({
					label: 'Header & Two-column',
					key: '1,2',
					layout: [{ cols: 1 }, { cols: 2 }],
				});
				options.push({
					label: 'Header, Two-column, Footer',
					key: '1,2,1',
					layout: [{ cols: 1 }, { cols: 2 }, { cols: 1 }],
				});
				return options;
			},

			currentLayout: function() {
				let result = this.layoutOptions.find((l) => l.key === this.page.layoutKey);
				if (!result) {
					result = this.layoutOptions[0];
				}
				return result;
			},

			pageLayout: function() {
				let result = [];
				let contentIndex = {
					index: 0,
				};
				for (let i = 0; i < this.currentLayout.layout.length; i++) {
					result.push(this.colsInRow(this.currentLayout.layout[i], contentIndex));
				}
				return result;
			},
		},
	};
</script>

<style scoped lang="scss">
	.custom-page {
		width: 100%;
		height: 100%;
		min-height: 100%;
		padding: 0;
		border: 0;
	}

	.custom-page-container {
		width: 100%;
		max-width: none;
		padding: 0;
	}

	.custom-page-column {
		padding: 0;
	}

	.custom-page-iframe {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.custom-page-iframe iframe {
		width: 100%;
		height: 100%;
		display: block;
		border: 0;
		overflow: auto;
	}
</style>
